export default "./images/survio-2Zgp5-assets-reference-fr.png";